import {
  SEARCH_PROVIDER_LIST,
  SEARCH_PROVIDER_LIST_FAILURE,
  SEARCH_PROVIDER_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getSearchProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_PROVIDER_LIST:
      return { ...state, loading: true };
    case SEARCH_PROVIDER_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case SEARCH_PROVIDER_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getSearchProviderReducer;
